import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { Grid } from "@material-ui/core";
import { ReportSectionHeader } from "../../common/components/SectionHeader";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import Axios from "axios";
import { apiUri } from "../../config";
import { withRouter } from "react-router-dom";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import AddCompany from "./addCompany";
import { isEmpty } from "lodash";
import { formatCurrencyUSD } from "../../util";

function CheckCompanies({
  user,
  selectedAceType,
  purchaseLimit,
  handleNext,
  totalValue,
  setTotalValue,
  history,
  selectedList,
  setSelectedList,
}) {
  const [listOfCompanies, setListOfCompanies] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const noOfCompanies = Number(purchaseLimit);

  const deleteCompany = (index) => {
    const newSelectedList = selectedList.filter((_, i) => i !== index);
    setSelectedList(newSelectedList);
  };

  const addCompany = () => {
    setSelectedList([...selectedList, {}]);
  };

  const selectCompany = (newValue, index) => {
    const updatedList = [...selectedList];
    updatedList[index] = newValue || {};
    setSelectedList(updatedList);
    setShowPopup(false);
  };

  const filterCompanies = (index) => {
    const selectedNamesAndCodes = selectedList.map((item) => item.companyId);
    return listOfCompanies.filter(
      (company) =>
        !selectedNamesAndCodes.includes(company.companyId)
    );
  };

  const handleSaveCompanies = () => {
    const payload = selectedList
      .filter((item) => !isEmptyObject(item))
      .map((company) => {
        return {
          registrationUuid: user.registrationUuid,
          companyId: company.companyId,
          companyName: company.companyName,
        };
      });

    Axios.post(`${apiUri}/register/saveSelectedCompanies`, payload)
      .then((response) => {
        if (
          response.data.response &&
          response.data.response.includes("User already registered")
        ) {
          NotificationManager.error(response.data.response, "Failure");
        } else if (selectedAceType === "1") {
          Axios.post(`${apiUri}/register/users/${user.registrationUuid}`, {registration: true})
            .then((res) => {
              history.push({
                pathname: "/Congratulations",
                state: { user: user, selectedCompanies: selectedList },
              });
            })
            .catch((err) => {
              NotificationManager.error(err.message, "Failure");
            });
        } else {
          handleNext();
        }
      })
      .catch((error) => {
        console.log("save companies error", error);
        NotificationManager.error(error.message, "Failure");
      });
  };

  const handleInputChange = (event, value) => {
    Axios.get(`${apiUri}/register/getCompanies?searchParam=${value}`)
      .then((response) => {
        if (response && response.data && response.data.content) {
          const companiesList = [...listOfCompanies, ...response.data.content];
          const uniqueCompaniesList = companiesList.filter(
            (company, index, self) =>
              index === self.findIndex((c) => c.companyId === company.companyId)
          );
          setListOfCompanies(uniqueCompaniesList);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        NotificationManager.error(error.message, "Failure");
      });
  };

  const isEmptyObject = (obj) =>
    Object.keys(obj).length === 0 && obj.constructor === Object;

  const getTotalValue = () => {
    const selectedCompaniesCount = selectedList.filter(
      (item) => !isEmptyObject(item)
    ).length;
    setTotalValue(selectedCompaniesCount * 4000);
  };

  useEffect(() => {
    if (selectedAceType !== "1") getTotalValue();
  }, [selectedList]);

  return (
    <Grid container style={{ justifyContent: "center" }}>
      <Grid item xs={12} sm={8} md={6}>
        <div style={{ margin: "0 8%", minHeight: 500 }}>
          <ReportSectionHeader>
            <Grid container>
              <Grid item xs={8} sm={8} md={8}>
                <h4>Select Company</h4>
              </Grid>
              <Grid item xs={4} sm={4} md={4} style={{ textAlign: "end" }}>
                {selectedList.length < noOfCompanies && (
                  <button
                    className="sar-btn"
                    style={{ margin: "0px" }}
                    onClick={() => {
                      addCompany();
                      handleInputChange("", "");
                      setShowPopup(true);
                    }}
                  >
                    Add Company
                  </button>
                )}
              </Grid>
            </Grid>
          </ReportSectionHeader>
          <br />
          <HeaderDivider />
          <Grid container style={{ paddingBottom: "10px"}}>
            <Grid item xs={8} sm={8} md={8}>
              <div style={{ color: "#fff", fontSize: "16px"}}>Company</div>
            </Grid>
            <Grid
              item
              xs={1}
              sm={1}
              md={1}
              style={{ textAlign: "left", color: "#fff", fontSize: "16px" }}
            ></Grid>
            <Grid
              item
              xs={3}
              sm={3}
              md={3}
              style={{ color: "#fff", fontSize: "16px", textAlign: "end" }}
            >
              <div>Licensing Fee</div>
            </Grid>
          </Grid>
          <HeaderDivider />
          {selectedList.length > 0 && !isEmpty(selectedList[0]) ? (
            <Grid container>
              {selectedList.map((company, index) => {
                return (
                  <React.Fragment key={`${company.symbol}-fragment-${index}`}>
                    {!isEmpty(company) ? (
                      <Grid
                        container
                        key={`${company.symbol}-${index}`}
                        style={{ marginBottom: "16px" }}
                      >
                        <Grid
                          item
                          xs={8}
                          sm={8}
                          md={8}
                          style={{
                            color: "#fff",
                            fontSize: "16px",
                            marginBottom: "10px",
                          }}
                        >
                          <div>
                            {`${company.companyName} (${company.market}:${company.symbol})`}
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={1}
                          sm={1}
                          md={1}
                          style={{
                            textAlign: "left",
                            color: "#fff",
                            fontSize: "16px",
                          }}
                        >
                          {selectedList.length > 0 && (
                            <FaTrash
                              className="dateOption trash_icon"
                              onClick={() => deleteCompany(index)}
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          style={{
                            color: "#fff",
                            fontSize: "16px",
                            textAlign: "end",
                          }}
                        >
                          <div>
                            {selectedAceType === "1"
                              ? formatCurrencyUSD(0)
                              : formatCurrencyUSD(4000)}
                          </div>
                        </Grid>
                      </Grid>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </Grid>
          ) : (
            <div style={{ color: "gray", textAlign: "center" }}>
              No Companies Selected.
            </div>
          )}
          <HeaderDivider style={{ marginTop: "10px" }} />
          <div className="invoice-total">
            Total: {formatCurrencyUSD(totalValue)}
          </div>
          <br />
          <br />
          <div className="right">
            <button
              className="sar-btn"
              style={{ margin: "0" }}
              disabled={
                selectedList.filter((item) => !isEmptyObject(item)).length === 0
              }
              onClick={handleSaveCompanies}
            >
              Next
            </button>
          </div><br />
          <div>
	          <p style={{"font-size": "x-small", color : "#fff"}}>
	          	SAR ACE Alerts are potentially available on all the issues of common stock or American depositary receipts of publicly traded companies that currently trade on the NYSE or NASDAQ. Share classes with insufficient data for robust event study analysis, including companies with fewer than 100 days of available trading data and those lacking sufficient available news feeds, are excluded from the SAR ACE Alert list.  SAR ACE Alerts will become unavailable when share classes cease to trade or relevant data becomes unavailable. 
	          </p>
	      </div>
        </div>
        {showPopup && (
          <AddCompany
            handleClose={() => {
              selectedList.pop();
              setShowPopup(false);
            }}
            selectedList={selectedList}
            listOfCompanies={listOfCompanies}
            selectCompany={selectCompany}
            handleInputChange={handleInputChange}
          />
        )}
        <NotificationContainer />
      </Grid>
    </Grid>
  );
}

export default withRouter(CheckCompanies);



// WEBPACK FOOTER //
// ./src/components/Register/companies.jsx